import { fetchAuthSession, getCurrentUser } from '@aws-amplify/auth';

export async function getIdTokenAuthHeaders({
  baseHeaders = {},
  forceRefresh = false,
  includeUserId = false,
} = {}) {
  const sessionOptions = forceRefresh ? { forceRefresh: true } : undefined;
  const { tokens } = await fetchAuthSession(sessionOptions);
  const idToken = tokens?.idToken?.toString();

  if (!idToken) {
    throw new Error('Missing Cognito ID token');
  }

  const headers = {
    ...baseHeaders,
    Authorization: `Bearer ${idToken}`,
  };

  if (includeUserId) {
    try {
      const user = await getCurrentUser();
      if (user?.username) {
        headers['user-id'] = user.username;
      }
    } catch {
      // Some call sites can authenticate without the username header.
    }
  }

  return headers;
}

export async function fetchWithIdTokenRetry(url, options = {}) {
  const {
    headers: baseHeaders = {},
    includeUserId = false,
    retryOnUnauthorized = true,
    ...fetchOptions
  } = options;

  let response = await fetch(url, {
    ...fetchOptions,
    headers: await getIdTokenAuthHeaders({ baseHeaders, includeUserId }),
  });

  if (retryOnUnauthorized && response.status === 401) {
    response = await fetch(url, {
      ...fetchOptions,
      headers: await getIdTokenAuthHeaders({
        baseHeaders,
        forceRefresh: true,
        includeUserId,
      }),
    });
  }

  return response;
}
